var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mappedComponent)?_c(_vm.mappedComponent,{tag:"component",attrs:{"message":_vm.message}}):_c('p',[_vm._v("Beep Boop Error! 🤖")])}
var staticRenderFns = []

export { render, staticRenderFns }